/* esm.sh - base-x@5.0.1 */
export * from "/*base-x@5.0.1/esnext/base-x.mjs";
export { default } from "/*base-x@5.0.1/esnext/base-x.mjs";
